'use strict';



import VoucherList from './components/voucher-list';

const voucherHolder = new Vue({
    el: '#voucher-holder',
    components: {
        VoucherList
    },
    data() {
        return {};
    }
});
